import React, { useState, useEffect } from 'react';
import '../../App.css';
import { useApp } from '../../core/context';
import { sb } from '../../core/db';
import { InlineIcon } from '../../components/Icon';

function ZohoWorkdriveSettings({ showToast }) {
  const { org, setOrg } = useApp();
  const [enabled, setEnabled] = useState(org.zoho_workdrive_enabled === true || org.zoho_workdrive_enabled === 'true');
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sb.getOrganisationZohoWorkdrive()
      .then((z) => {
        if (z?.zoho_workdrive_enabled !== undefined) {
          setEnabled(z.zoho_workdrive_enabled === true || z.zoho_workdrive_enabled === 'true');
        }
        setConfigured(!!z?.configured);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      await sb.updateOrganisationZohoWorkdrive({ zoho_workdrive_enabled: enabled });
      setOrg({ ...org, zoho_workdrive_enabled: enabled });
      showToast('WorkDrive settings saved', 'success');
    } catch (e) {
      showToast(e.message || 'Failed to save', 'error');
    }
  };

  return (
    <div style={{ maxWidth: 640 }}>
      <div className="card">
        <div className="card-head">
          <div className="card-title">
            <InlineIcon name="upload" size={16} gap={6}>Zoho WorkDrive</InlineIcon>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="f-hint">Loading…</div>
          ) : (
            <>
              <div
                style={{
                  padding: '10px 14px',
                  background: configured ? '#ECFDF5' : '#F3F4F6',
                  border: `1px solid ${configured ? '#A7F3D0' : 'var(--border)'}`,
                  borderRadius: 8,
                  fontSize: 13,
                  color: configured ? '#065F46' : 'var(--muted)',
                  marginBottom: 16,
                }}
              >
                {configured
                  ? 'WorkDrive is connected. You can turn document sync on or off below.'
                  : 'WorkDrive connection is being set up on the server. You can save your preference now; sync will begin once connection is ready.'}
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={enabled}
                  onChange={(e) => setEnabled(e.target.checked)}
                />
                Sync uploaded client documents to WorkDrive
              </label>
              <div className="f-hint" style={{ marginTop: 8 }}>
                Each company gets its own folder. Files upload to the portal first, then copy to WorkDrive when sync is on.
              </div>
            </>
          )}
        </div>
        <div style={{ padding: '0 20px 20px' }}>
          <button className="btn btn-primary" onClick={save} disabled={loading}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export { ZohoWorkdriveSettings };
